<template>
  <main>
    <checkout-authentication v-if="isAuthenticating" :initialAuthType="initialAuthType" :isInsideDialog="isInsideDialog" />
    <div class="checkout-container" v-else>
      <checkout-purchase :isInsideDialog="isInsideDialog" :offer="offer" />
    </div>
  </main>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'checkout-flow',
  props: {
    isInsideDialog: Boolean,
    offer: String
  },
  data: () => ({
    isAuthenticating: true,
    initialAuthType: null
  }),
  watch: {
    isUserAuthenticated: 'resolveScreen',
    isProfileLoaded: 'resolveScreen',
    isUserSubscribed: 'resolveScreen',
    isAuthenticating: 'resolveInitialAuthType'
  },
  computed: {
    ...mapState({
      isUserAuthenticated: state => state.authentication.authenticated,
      userSignedUp: state => state.authentication.signedUp,
      isProfileLoaded: state => state.user.isProfileLoaded,
      isUserSubscribed: state => state.user.isSubscribed
    })
  },
  methods: {
    resolveScreen() {
      if (this.isAuthenticating) {
        this.isAuthenticating = !this.isUserAuthenticated || !this.isProfileLoaded || this.isUserSubscribed
      }
    },
    resolveInitialAuthType(val, oldVal) {
      if (val && !oldVal) {
        this.initialAuthType = 'email'
      } else {
        this.initialAuthType = 'signup'
      }
    }
  },
  created() {
    this.isAuthenticating = !this.isUserAuthenticated
    // if (!this.isUserAuthenticated) {
    //   this.$router.replace({ name: 'signup' })
    // }
  }
}
</script>

<style lang="scss" scoped>
main {
  flex-grow: 1;
  overflow: visible;

  .checkout-container {
    margin-top: 0;
  }
}
</style>
